import { render, staticRenderFns } from "./UkrposhtaTableUser.vue?vue&type=template&id=13ac26d4&scoped=true"
import script from "./UkrposhtaTableUser.vue?vue&type=script&lang=js"
export * from "./UkrposhtaTableUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ac26d4",
  null
  
)

export default component.exports